import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Col, Row, Button, Dropdown } from "react-bootstrap";
import { SXDropdown } from "@common/components/ui-components/SXDropdown";
import { SXModalBase } from "./SXModal";
import { useTranslation } from "react-i18next";
import { openModal, closeModal, selectModalById } from "../../features/ui/uiSlice";
import "../../../i18n";
import { languages } from "../../config/languages";

interface SettingsModalProps {
  isSettingsModalOpen: boolean;
}

export const SettingsModal = (props: SettingsModalProps) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const handleLanguageSelect = async (langCode: string) => {
    localStorage.setItem("i18nextLng", langCode);
    await i18n.changeLanguage(langCode);
  };

  // const currentLanguage = languages.find((lang) => lang.code === i18n.language);

  return (
    <SXModalBase
      header={t("settings")}
      show={props.isSettingsModalOpen}
      size="lg"
      close={() => {
        dispatch(closeModal("settingsModal"));
      }}
      bodyStyle={{ overflow: "visible" }}
      body={
        <Container>
          <Row style={{ marginBottom: "3rem" }}>
            <Col xs={2}>{t("language")}</Col>
            <Col xs={3}>
              <SXDropdown
                name="language"
                list={languages}
                val={languages.find((el) => el.id === i18n.language) || null}
                localisation={i18n}
                lang={i18n.language}
                style={{ paddingRight: 50 }}
                onUpdate={async (value) => {
                  if (value === null) {
                    return;
                  }
                  handleLanguageSelect(String(value.id));
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col></Col>
            <Col></Col>
            <Col></Col>
            <Col></Col>
          </Row>
        </Container>
      }
      footer={
        <>
          <Button
            className="modal-btn"
            onClick={() => {
              dispatch(closeModal("settingsModal"));
            }}
          >
            {t("cancel")}
          </Button>
          <Button
            id="disclaimerok"
            className="modal-btn"
            onClick={() => {
              dispatch(closeModal("settingsModal"));
            }}
          >
            {t("ok")}
          </Button>
        </>
      }
    />
  );
};
